enum ErrorMessages {
  AlreadyValidated = 'Inscrito ya validado.',
  Unauthorized = 'Inscrito sin autorizacion Datadis.',
  ValidationError = 'Error validando al inscrito.',
  ErrorCup = 'Error validando al inscrito. CUPS del cliente no es correcto.',
}

export default ErrorMessages;
